// extracted by mini-css-extract-plugin
export default {"table":"_2UIFB_EGg6geVMufed6efd","icon":"UCNGS0yeCqOxelFjhdh2e","tooltipContent":"y4x8LHu1kcv4vYrxhajNo"};